import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/mine',
  name: 'mine',
  meta: {
    title: '我的',
    auth: true,
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'contact-o',
  to: {
    name: route.name,
  },
};
